import {
  IPendingSignatureItem,
  OwnerDocumentStatusFilter,
} from "../types/ownerDashboard.types";

export function filterPendingSignaturesByTab(
  items: IPendingSignatureItem[],
  tab: OwnerDocumentStatusFilter
): IPendingSignatureItem[] {
  if (tab === "signed") {
    return items.filter((item) => item.document_status === "signed");
  }

  return items.filter((item) => item.document_status === "pending");
}
